<template>
  <div class="flex flex-row items-center justify-center gap-2 flex-wrap w-full">
    <PButton
      v-for="(option, index) in fixed_options"
      :key="option.index"
      :variant="selected_index === index ? '' : 'outlined'"
      @click="!disabled && selectAnswer(index)"
      class="w-full"
    >
      <div>
        {{ index + 1 + '. ' + option }}
      </div>
    </PButton>
  </div>
</template>

<script setup>
import { defineProps, ref } from 'vue';

const props = defineProps({
  disabled: { type: Boolean, default: false },
  fixed_options: { type: Array, required: true },
});

const selected_index = ref(null);

const emits = defineEmits(['scoreSelected']);
const selectAnswer = (index) => {
  selected_index.value = index;
  emits('scoreSelected', index);
};
</script>
